<mat-sidenav-container class="sidenav-container">
	<mat-sidenav-content class="sidenav-content">
		<router-outlet></router-outlet>
	</mat-sidenav-content>

	<mat-sidenav #sidenav [mode]="sidenavMode" class="sidenav" (openedChange)="onOpenedChange($event)">
		@if (client$ | async; as client) {
			<div class="menu-section">
				<ui-pm-user-profile
					[fullName]="client.fullName"
					(editProfile)="router.navigate(['perfil/editar'])"
				/>
				<h3>Conta</h3>
				<mat-nav-list>
					<a mat-list-item routerLink="carteira">
						<div class="center-text">
							<mat-icon svgIcon="pm-icons:wallet">account_balance_wallet</mat-icon>
							<span>Carteira</span>
						</div>
					</a>
					<a mat-list-item routerLink="favoritos">
						<div class="center-text">
							<mat-icon svgIcon="pm-icons:favorite">favorite_border</mat-icon>
							<span>Favoritos</span>
						</div>
					</a>
					<a mat-list-item (click)="changeTheme()" *ngIf="showChangeTheme">
						<div class="center-text">
							<mat-icon svgIcon="pm-icons:edit-card">change_theme</mat-icon>
							<span>Alterar tema</span>
						</div>
					</a>
					<a mat-list-item routerLink="reservas-e-checkins">
						<div class="center-text">
							<mat-icon svgIcon="pm-icons:calendar">history</mat-icon>
							<span>Histórico</span>
						</div>
					</a>
					<a mat-list-item (click)="logout()">
						<div class="center-text">
							<mat-icon svgIcon="pm-icons:logout">exit_to_app</mat-icon>
							<span>Sair</span>
						</div>
					</a>
				</mat-nav-list>
			</div>
			<div class="menu-section">
				<ui-common-divisor />
			</div>
		}
		<div class="menu-section" style="margin-top: 20px">
			<h3>Ajuda e políticas</h3>
			<mat-nav-list>
				<a mat-list-item routerLink="como-funciona">
					<div class="center-text">
						<mat-icon svgIcon="pm-icons:info">help_outline</mat-icon>
						<span>Como funciona</span>
					</div>
				</a>
				<a mat-list-item routerLink="/faq">
					<div class="center-text">
						<mat-icon svgIcon="pm-icons:help-circle">question_answer</mat-icon>
						<span>FAQ</span>
					</div>
				</a>
				<a mat-list-item routerLink="politica-de-privacidade">
					<div class="center-text">
						<mat-icon svgIcon="pm-icons:shield">security</mat-icon>
						<span>Política de privacidade</span>
					</div>
				</a>
				<a mat-list-item routerLink="termos-de-uso">
					<div class="center-text">
						<mat-icon svgIcon="pm-icons:file-text">description</mat-icon>
						<span>Termos de uso</span>
					</div>
				</a>
				<a mat-list-item routerLink="sobre-a-tagme">
					<div class="center-text">
						<mat-icon svgIcon="pm-icons:info">info</mat-icon>
						<span>Sobre a Tagme</span>
					</div>
				</a>
			</mat-nav-list>
		</div>
	</mat-sidenav>
</mat-sidenav-container>
